import { LitElement, html, css, t, paths, unsafeHTML } from '@hh/global.js'

class HHBundleShare extends HTMLElement {
  constructor() {
    super()
    this.onUrlUpdate = this.onUrlUpdate.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    const form = this.querySelector('form');
    this.input = this.querySelector('input');
    this.message = this.querySelector('[data-message]');
    if (form) {
      form.addEventListener('submit', this.onSubmit);
    }
  }

  onSubmit(e) {
    e.preventDefault();
    this.copyToClipboard();
  }

  connectedCallback() {
    document.addEventListener('updateShareUrl', this.onUrlUpdate)
  }

  disconnectedCallback() {
    document.removeEventListener('updateShareUrl', this.onUrlUpdate)
  }

  onUrlUpdate() {
    this.input.value = window.location.href;
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.input.value).then(() => {
      this.message.classList.remove('hidden')
      this.message.setAttribute('aria-hidden', false)

      setTimeout(() => {
        this.message.setAttribute('aria-hidden', true)
        this.message.classList.add('hidden')
      }, 6000)
    })
  }
}

if (!customElements.get('hh-bundle-share')) {
  customElements.define('hh-bundle-share', HHBundleShare);
}